import { render, staticRenderFns } from "./serveList.vue?vue&type=template&id=7f727213&scoped=true&"
import script from "./serveList.vue?vue&type=script&lang=js&"
export * from "./serveList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f727213",
  null
  
)

export default component.exports